package io.horion.cv.pages

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.WhiteSpace
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.framework.annotations.DelicateApi
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import io.horion.cv.components.Footer
import io.horion.cv.components.Topbar
import io.horion.cv.utils.Colors
import io.horion.cv.utils.Constants.INTER
import io.horion.cv.utils.Constants.UBUNTU
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Text

@OptIn(DelicateApi::class)
@Page("confirmation")
@Composable
fun ConfirmationPage() {
    val ctx = rememberPageContext()
    val breakpoint = rememberBreakpoint()
    val isMobile = breakpoint <= Breakpoint.MD

    Column(
        modifier = Modifier.fillMaxWidth(),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        Topbar()

        Column(
            modifier = Modifier
                .fillMaxWidth()
                .padding(topBottom = if (isMobile) 50.px else 70.px, ),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            SpanText(
                text = "Confirmation Email",
                modifier = Modifier
                    .fontSize(if (isMobile) 28.px else 32.px)
                    .fontWeight(FontWeight.Normal)
                    .fontFamily(UBUNTU)
                    .color(Colors.black)
                    .margin(bottom = if (isMobile) 30.px else 50.px)
            )

            Image(
                src = "email-icon.svg",
                description = "Email confirmation icon",
                modifier = Modifier
                    .size(50.px)
                    .margin(bottom = if (isMobile) 10.px else 0.px)
            )

            SpanText(
                text = "Un lien de confirmation a été envoyé à talandem@gmail.com.",
                modifier = Modifier
                    .fontSize(if(isMobile) 16.px else 18.px)
                    .color(Colors.black)
                    .fontWeight(FontWeight.Medium)
                    .fontFamily(INTER)
                    .textAlign(TextAlign.Center)
            )

            SpanText(
                text = "Accédez à votre boîte de réception\npour confirmer la création",
                modifier = Modifier
                    .fontSize(if (isMobile) 16.px else 18.px)
                    .color(Colors.black)
                    .fontWeight(FontWeight.Medium)
                    .fontFamily(INTER)
                    .textAlign(TextAlign.Center)
                    .whiteSpace(if (isMobile) WhiteSpace.PreWrap else WhiteSpace.Normal)
            )

            SpanText(
                text = " de votre compte en cliquant sur le lien.",
                modifier = Modifier
                    .fontSize(if (isMobile) 16.px else 18.px)
                    .color(Colors.black)
                    .fontWeight(FontWeight.Medium)
                    .fontFamily(INTER)
                    .textAlign(TextAlign.Center)
                    .margin(bottom = 40.px)
            )

            Button(
                onClick = { ctx.router.navigateTo("/") },
                modifier = Modifier
                    .height(40.px)
                    .padding(topBottom = 10.px, leftRight = if (isMobile) 20.px else 50.px)
                    .fontFamily(INTER)
                    .fontSize(if (isMobile) 16.px else 18.px)
                    .fontWeight(FontWeight.Normal)
                    .borderRadius(5.px)
                    .border(if (isMobile) 1.px else 2.px, LineStyle.Solid, Colors.LighterBlue)
                    .color(Colors.LighterBlue)
                    .backgroundColor(Colors.White)
                    .styleModifier {
                        property("display", "flex")
                        property("align-items", "center")
                        property("justify-content", "center")
                    }
            ) {
                Text("Ok")
            }
        }
        Footer()
    }
}